import jwtDecode from 'jwt-decode';
import { verify, sign } from 'jsonwebtoken';
import baseService from '../services/base.service';
// ----------------------------------------------------------------------

const isValidToken = (accessToken: string) => {
  if (!accessToken) {
    return false;
  }
  const decoded = jwtDecode<{ exp: number }>(accessToken);
  const currentTime = Date.now() / 1000;

  return decoded.exp > currentTime;
};

 const handleTokenExpired = (exp: any) => {
  let expiredTimer;

  window.clearTimeout(expiredTimer);
  const currentTime = Date.now();
  const timeLeft = exp * 1000 - currentTime;
  expiredTimer = window.setTimeout(() => {
    console.log('expired');
    localStorage.removeItem('accessToken');
    delete baseService.defaults.headers.Authorization;
  }, timeLeft);
};

const setSession = (accessToken: string | null) => {
  if (accessToken) {
    localStorage.setItem('accessToken', accessToken);
    baseService.defaults.headers.Authorization = `Bearer ${accessToken}`;
    // This function below will handle when token is expired
    const { exp }: any = jwtDecode(accessToken);
    handleTokenExpired(exp);
  } else {
    localStorage.removeItem('accessToken');
    delete baseService.defaults.headers.Authorization;
  }
};

export { isValidToken, setSession };
